import {Component, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';
import {IAlert} from './alert.interface';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {

  @Input() staticAlertClosed: boolean;
  @Input() alert: IAlert;
  @Output() state = new EventEmitter<boolean>();

  closeAlert(): void {
    this.state.emit(true);
  }
}
